



































import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import averageDeliveryTimeByArea from '@/gql/managementReport/04-DeliveryTime/averageDeliveryTimeByArea.gql';
import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';
import {
  deliveryTimeColor,
  deliveryTimeColorHue,
} from '@/useDelivery';

import CommonHubSelector from '@/components/CommonHubSelector.vue';
import ChartWithMoneyAxis from '@/components/Vivat/Chart/ChartWithMoneyAxis.vue';
import useAuth from '@/useAuth';

const AverageDeliveryTimeByArea = defineComponent({
  components: {
    CommonHubSelector,
    ChartWithMoneyAxis,
  },
  props: {
    height: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { me } = useAuth();
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });
    const toCommaFormat = (val: number, min = 0, max = 0) => val.toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });

    const { result, loading } = useQuery(averageDeliveryTimeByArea,
      computed(() => {
        const vars = {
          timeframe: filter.monthRange,
          hubId: undefined,
        };

        if (filter.hub && me.hub.hubType === 'MAIN') {
          vars.hubId = (filter.hub as any)?.id;
        } else if (me.hub.hubType !== 'MAIN') {
          vars.hubId = me.hub.id as any;
        }

        return vars;
      }));

    const getDataArray = computed(() => {
      if (loading.value === false) {
        return result.value?.averageDeliveryTimeByArea || { duration: [], hubDuration: [] };
      }
      return {
        duration: [],
        hubDuration: [],
      };
    });

    const labels = computed(() => ({
      duration: getDataArray.value.duration?.map((item: any) => item.area) || [],
      hubDuration: getDataArray.value.hubDuration?.map((item: any) => item.area) || [],
    }));
    const data = computed(() => ({
      duration: getDataArray.value?.duration?.map((item: any) => toCommaFormat(item.amount, 1, 1)) || [],
      hubDuration: getDataArray.value?.hubDuration?.map((item: any) => toCommaFormat(item.amount, 1, 1)) || [],
    }));

    const plugins = {
      legend: {
        display: false,
      },
    };
    const chartData = computed(() => ({
      labels: labels.value.duration,
      datasets: [
        {
          label: 'ระยะเวลาส่งถึงศูนย์กระจายสินค้า',
          data: data.value.hubDuration,
          stack: 'CURRENT',
          backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--color-primary-300'),
          // backgroundColor: (ctx: any) => {
          //   const index = ctx.dataIndex;
          //   const value: 1 | 2 | 3 = ctx.dataset.data[index] || 1;
          //   const roundedValue: 1 | 2 | 3 = Math.ceil(value as number) as 1 | 2 | 3;
          //   if (roundedValue > 7) return deliveryTimeColorHue.day7;
          //   if (roundedValue > 3) return deliveryTimeColorHue.day4;
          //   return deliveryTimeColorHue[`day${roundedValue}`];
          // },
        },
        {
          label: 'ระยะเวลาส่งถึงปลายทาง',
          data: data.value.duration,
          stack: 'CURRENT',
          backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--color-primary-500'),
          // backgroundColor: (ctx: any) => {
          //   const index = ctx.dataIndex;
          //   const value: 1 | 2 | 3 = ctx.dataset.data[index] || 1;
          //   const roundedValue: 1 | 2 | 3 = Math.ceil(value as number) as 1 | 2 | 3;
          //   if (roundedValue > 7) return deliveryTimeColor.day7;
          //   if (roundedValue > 3) return deliveryTimeColor.day4;
          //   return deliveryTimeColor[`day${roundedValue}`];
          // },
        },
      ],
    }));

    const computedMaxYScale = computed(() => {
      const allData = data.value.duration.map((d: string, index: number) => parseFloat(d) + parseFloat(data.value.hubDuration[index]));
      const max = Math.max(...allData) + 0.05;
      if (!Number.isInteger(max)) {
        if (max < 1) {
          return 1;
        }
        if (max < 10) {
          return Math.ceil(max + (max * (15 / 100)));
        }
        if (max < 100) {
          return Math.ceil(max / 10) * 10;
        }
        if (max < 1000) {
          return Math.ceil(max / 100) * 100;
        }
        return Math.ceil(max + (max * (10 / 100)));
      }
      return Math.ceil(max + (max * (15 / 100))); // +15% clearance from top (y axis)
    });

    return {
      me,
      filter,
      plugins,
      computedMaxYScale,
      chartData,
    };
  },
});

export default AverageDeliveryTimeByArea;
